import { render, staticRenderFns } from "./PeriodRateMaskList.vue?vue&type=template&id=2324763c&scoped=true&"
import script from "./PeriodRateMaskList.vue?vue&type=script&lang=js&"
export * from "./PeriodRateMaskList.vue?vue&type=script&lang=js&"
import style0 from "./PeriodRateMaskList.vue?vue&type=style&index=0&id=2324763c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2324763c",
  null
  
)

export default component.exports